import * as types from './ActionTypes';
import { gcApi, omtApi } from 'config/axios';
import axios from 'axios';
import NavigationUtil from 'utils/NavigationUtil';

// Fetches
export function fetchDeviceBetaSoftwareInfo(
    deviceId,
    partNumber,
    currentFirmwareVersionMajor,
    currentFirmwareVersionMinor
) {
    return {
        type: types.FETCH_DEVICE_BETA_SOFTWARE_INFO,
        deviceId,
        partNumber,
        currentFirmwareVersionMajor,
        currentFirmwareVersionMinor
    };
}

// This endpoint simply returns true or false
export function fetchDeviceBetaSoftwareAvailable(deviceId, callback) {
    return gcApi
        .get(`/publicbetasoftware-service/pbs/available/${deviceId}`)
        .then((response) => {
            callback(response.data);
        })
        .catch((error) => {
            callback(null);
        });
}

// Updates

// This is an OMT endpoint, docs here: https://confluence.garmin.com/pages/viewpage.action?spaceKey=MAPTECH&title=Analytics+APIs
export const sendAnalytics = (dataObj, callback = null) => {
    // prettier-ignore
    return omtApi
        .post(`/Rce/ProtobufApi/Analytics/ReportGenericAnalyticEvents`, dataObj, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Garmin-Client-Name': 'ConnectWeb',
                'Garmin-Client-Version': window.URL_BUST_VALUE.split(".").slice(0, 3).join("."),
                'Garmin-Client-Platform': 'WebBrowser',
                'Garmin-Client-Platform-Version': window.navigator.userAgent
            }
        })
        .then((response) => {
            if (typeof callback === 'function') {
                callback(response);
            }
        })
        .catch((error) => {
            if (typeof callback === 'function') {
                callback(error, true);
            }
        });
};

export const joinOrLeaveDeviceBeta = (deviceId, enrollStatus, successCallback) => {
    return gcApi
        .put(`/publicbetasoftware-service/pbs/${deviceId}?enrolled=${enrollStatus}`, {
            deviceId: deviceId,
            enrollStatus: enrollStatus
        })
        .then(() => {
            successCallback(true);
        })
        .catch(() => {
            successCallback(false);
        });
};

// Alpha enrollment (aka, the old Prod Beta)
export const enrollInAlpha = () => {
    const url = NavigationUtil.url('/service/beta');

    axios.post(url, null, { baseURL: '/' }).then(() => {
        // todo: remove this if condition and comment in CA-161209
        // The Alpha Features, aka Prod Beta, only works in Prod so this feature can only be fully tested in that env
        // > this temp code allows QA to verify that both POST and DELETE calls necessary for the Alpha Features to be enabled/disabled are made w/o reloading the page on local/Test/VM
        // > this is b/c reloading after enabling wouldn't allow the DELETE call to be verified
        // > this condition will allow the full functionality to happen on Prod
        // > after the Alpha Features are tested in Prod, the old Join/Leave Beta Experience button in the nav menu and this logic can be removed in CA-161209
        if (
            window.location.href.indexOf('local') > -1 ||
            window.location.href.indexOf('connecttest') > -1 ||
            window.location.href.indexOf('CA-161209') > -1
        ) {
            return;
        }

        window.location.reload();
    });
};

export const unenrollInAlpha = () => {
    const url = NavigationUtil.url('/service/beta');

    axios.delete(url, { baseURL: '/' }).then(() => {
        // todo: remove this if condition and comment in CA-161209
        // The Alpha Features, aka Prod Beta, only works in Prod so this feature can only be fully tested in that env
        // > this temp code allows QA to verify that both POST and DELETE calls necessary for the Alpha Features to be enabled/disabled are made w/o reloading the page on local/Test/VM
        // > this is b/c reloading after enabling wouldn't allow the DELETE call to be verified
        // > this condition will allow the full functionality to happen on Prod
        // > after the Alpha Features are tested in Prod, the old Join/Leave Beta Experience button in the nav menu and this logic can be removed in CA-161209
        if (
            window.location.href.indexOf('local') > -1 ||
            window.location.href.indexOf('connecttest') > -1 ||
            window.location.href.indexOf('CA-161209') > -1
        ) {
            return;
        }

        window.location.reload();
    });
};
